var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('dictionary-simple-table',{attrs:{"dictionary_link":"/product-shipment-sizes","title":"Lista wielkości przesyłek","numeral_text":['wielkość przesyłek', 'wielkości przesyłek', 'wielkości przesyłek'],"columns_title":['name']}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }